<template>
  <div
    v-if="isVisible"
    class="modal fade show d-block"
    tabindex="-1"
    style="background: rgba(0, 0, 0, 0.5)"
    @click.self="hide"
  >
    <div class="modal-dialog modal-lg modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header text-dark">
          <h5 class="modal-title fs-5">EVENTO OBSERVADO</h5>
          <button
            type="button"
            class="btn-close btn-close-dark"
            @click="hide"
          ></button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-12">
              <label class="form-label"
                ><strong>Motivo de la Observación:</strong></label
              >
              <textarea
                class="form-control"
                rows="4"
                v-model="event.obs"
                readonly
                placeholder="No se proporcionó un motivo específico."
              ></textarea>
            </div>
            <div class="col-12 text-primary">
              <strong>Próximos pasos:</strong>
              <ul class="mb-0 mt-2">
                <li>- Revise las observaciones realizadas.</li>
                <li>- Realice las correcciones necesarias.</li>
                <li>
                  - Vuelva a enviar el evento con las mejoras implementadas.
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" @click="hide">
            Cerrar
          </button>
          <button
            type="button"
            class="btn btn-primary"
            @click="acknowledgeObservation"
          >
            Entendido
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";

const props = defineProps({
  event: {
    type: Object,
    default: () => ({}),
  },
});

const emit = defineEmits(["acknowledged"]);

const isVisible = ref(false);

const acknowledgeObservation = () => {
  emit("acknowledged", props.event);
  hide();
};

const show = () => {
  isVisible.value = true;
  document.body.style.overflow = "hidden";
};

const hide = () => {
  isVisible.value = false;
  document.body.style.overflow = "";
};

defineExpose({
  show,
  hide,
});
</script>
